// Third Party
import * as React from 'react';

// Utils
import { useSubscribeEmailToNewsletterMutation } from '@gql';

// UI
import { Button } from '@components/button';
import { Icon, IconNames } from '@components/icon';
import { Input } from '@components/form/input';
import { Spinner } from '@components/spinner';
import { Typography } from '@components/typography';
import { FormElementGroup } from '@components/form/form-element-group';

export type Props = {};

export const NewsletterForm: React.FC<Props> = ({}) => {
  const [email, setEmail] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSubscribed, setIsSubscribed] = React.useState(false);

  const [subscribeEmailToNewsletter] = useSubscribeEmailToNewsletterMutation();

  const onChangeHandler = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(value);
  };

  const onSubmitHandler = async (
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await subscribeEmailToNewsletter({ variables: { email } });
      setEmail('');
      setIsSubscribed(true);
    } catch (error) {
      console.error('Failed to add contact:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubscribed) {
    return (
      <div className="flex flex-col gap-2">
        <Typography variant="subtitle2" className="text-secondary-light">
          Thanks for subscribing!
        </Typography>
        <Typography variant="body2" className="text-secondary-light">
          Check your inbox for confirmation
        </Typography>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-center justify-end gap-4 lg:space-x-2 xl:flex-row border-t-2 border-primary-main pt-4 lg:border-none lg:pt-0">
      <Typography variant="body1" className="text-secondary-xlight">
        Sign up for our newsletter:
      </Typography>
      <form
        onSubmit={onSubmitHandler}
        className="flex flex-row justify-center gap-2"
      >
        <FormElementGroup>
          <Input
            ariaLabel="email"
            alt="subscribe to newsletter"
            label="Email"
            name="email"
            type="email"
            leftContent={<Icon name={IconNames.PAPER_PLANE} />}
            value={email}
            onChange={onChangeHandler}
            className="border-0 sm:max-w-lg"
          />

          <Button
            type="submit"
            color="primary"
            size="lg"
            className="w-24 min-w-[96px] items-center justify-center self-end border-0"
            disabled={isSubmitting}
          >
            <div className="flex w-full justify-center">
              {isSubmitting ? <Spinner /> : 'Submit'}
            </div>
          </Button>
        </FormElementGroup>

        {/* <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--> */}
        <div
          style={{ position: 'absolute', left: '-5000px' }}
          aria-hidden="true"
        >
          <input
            type="text"
            name="b_5b96ebc913818d363151bbe46_2f838d472e"
            tabIndex={-1}
            defaultValue=""
          />
        </div>
      </form>
    </div>
  );
};
